import {ChildEntity} from "typeorm";
import {Player} from "@/modules/team/entity";
import {Notification} from "@/modules/notifications/entity";
import {LocationAsRelativeRaw} from "vue-router";
import {ShallowRef} from "vue";
import {Component} from "@vue/runtime-core";
import TransferOfferNotificationComponent from "@/modules/transfer-market/components/TransferOfferNotification.vue";

@ChildEntity()
export class TransferOfferNotification extends Notification {
  setPayload(player: Player) {
    this.payloadRaw = JSON.stringify({playerId: player.id, playerName: player.shortName});

    return this;
  }

  get payload(): { playerId: number, playerName: string } {
    return JSON.parse(this.payloadRaw!);
  }

  get to(): LocationAsRelativeRaw | undefined {
    return {name: 'transfer-market.team-offers.index'};
  }

  get component(): ShallowRef<Component> {
    return shallowRef(TransferOfferNotificationComponent);
  }
}